import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-20 bg-[#111827] border-y border-gray-800/50" data-id="element-150">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-152">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center uppercase tracking-wide" data-id="element-153">
            SI SOS NEURÓLOGO O PSIQUIATRA, ESTO TE VA A SONAR FAMILIAR...
          </h2>

          <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-154">
            <p data-id="element-155">
              Terminás tu última consulta del día. Estás agotado, pero el
              trabajo real recién empieza.
            </p>
            <p data-id="element-156">
              Abrís la computadora. Buscás el modelo de informe del año pasado.
              Intentás adaptar las frases para que esta vez la auditoría de
              OSDE, Swiss Medical o PAMI no te lo devuelva con un "documentación
              insuficiente".
            </p>
            <p data-id="element-157">
              Son las 10 de la noche y todavía no terminaste el informe de CUD
              que la familia necesita para mañana.
            </p>
            <p data-id="element-158">
              La cabeza no se apaga. Y no es por falta de compromiso con tus
              pacientes. Es porque sostenés solo un sistema que fue diseñado
              para consumirte el tiempo.
            </p>
            <div className="p-6 bg-[#1a2332] rounded-xl border-l-4 border-yellow-500 my-8" data-id="element-159">
              <p className="italic text-gray-200" data-id="element-160">
                Peor aún: llega la consulta de seguimiento y el padre te dice
                "Y... igual que siempre, doctor". No porque el niño no haya
                avanzado. Sino porque nadie registró el avance de manera que la
                familia pueda verlo.
              </p>
            </div>
            <p data-id="element-161">
              Cada semana armando material desde cero. Cada informe peleando con
              la burocracia. Cada consulta explicando lo mismo que explicaste la
              semana pasada.
            </p>
            <p className="font-bold text-white text-xl mt-8" data-id="element-162">
              Y tu WhatsApp. Siempre tu WhatsApp.
            </p>
            <p data-id="element-163">
              Audios de 5 minutos un sábado a la tarde. Mensajes de "Doctor,
              ¿qué hago?" a las 11 de la noche. Familias que preguntan si es
              normal que el niño no tenga apetito con la medicación. Familias
              que preguntan si pueden bajar la dosis porque "esta semana estuvo
              bien".
            </p>
            <p className="text-xl font-semibold text-yellow-500 mt-8 text-center" data-id="element-164">
              No es vocación. Es un sistema roto que te está robando tiempo,
              energía y vida personal.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}